import { $, $$, insertHTML } from 'utils/dom';

const videoBanner = $$('.banner-teaser--video');

videoBanner.length &&
  videoBanner.forEach(banner => {
    const video = $('video', banner);
    const videoSources = JSON.parse(video.dataset.source.replace(/\\/g, ''));
    const randomSource = Math.floor(Math.random() * videoSources.length);
    insertHTML(
      video,
      'beforeend',
      `<source src=${videoSources[randomSource].src} type="video/mp4">`
    );
  });
